import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { Texture } from 'pixi.js';

// Define the mapping configuration
const symbolConfig: Record<number, { blurSymName: string; staticSymName: string; skeleton: string; atlas: string }> = {
    0: {
        blurSymName: "wildBlur",
        staticSymName: "wildStatic",
        skeleton: "wildSkel",
        atlas: "wildAtlas"
    },
    1: {
        blurSymName: "lv5Blur",
        staticSymName: "lv5Static",
        skeleton: "lv5Skel",
        atlas: "lv5Atlas"
    },
    2: {
        blurSymName: "lv4Blur",
        staticSymName: "lv4Static",
        skeleton: "lv4Skel",
        atlas: "lv4Atlas"
    },
    3: {
        blurSymName: "lv3Blur",
        staticSymName: "lv3Static",
        skeleton: "lv3Skel",
        atlas: "lv3Atlas"
    },
    4: {
        blurSymName: "lv2Blur",
        staticSymName: "lv2Static",
        skeleton: "lv2Skel",
        atlas: "lv2Atlas"
    },
    5: {
        blurSymName: "lv1Blur",
        staticSymName: "lv1Static",
        skeleton: "lv1Skel",
        atlas: "lv1Atlas"
    },
    6: {
        blurSymName: "hv5Blur",
        staticSymName: "hv5Static",
        skeleton: "hv5Skel",
        atlas: "hv5Atlas"
    },
    7: {
        blurSymName: "hv4Blur",
        staticSymName: "hv4Static",
        skeleton: "hv4Skel",
        atlas: "hv4Atlas"
    },
    8: {
        blurSymName: "hv3Blur",
        staticSymName: "hv3Static",
        skeleton: "hv3Skel",
        atlas: "hv3Atlas"
    },
    9: {
        blurSymName: "hv2Blur",
        staticSymName: "hv2Static",
        skeleton: "hv2Skel",
        atlas: "hv2Atlas"
    },
    10: {
        blurSymName: "hv1Blur",
        staticSymName: "hv1Static",
        skeleton: "hv1Skel",
        atlas: "hv1Atlas"
    },
    22: {
        blurSymName: "goldCoinBlur",
        staticSymName: "goldCoinStatic",
        skeleton: "goldCoinSkel",
        atlas: "goldCoinAtlas"
    },
    13: {
        blurSymName: "spSymbolPoseidonBlur",
        staticSymName: "spSymbolPoseidonStatic",
        skeleton: "spSymbolPoseidonSkel",
        atlas: "spSymbolPoseidonAtlas"
    },
    14: {
        blurSymName: "spSymbolHadesBlur",
        staticSymName: "spSymbolHadesStatic",
        skeleton: "spSymbolHadesSkel",
        atlas: "spSymbolHadesAtlas"
    },
    15: {
        blurSymName: "spSymbolZeusBlur",
        staticSymName: "spSymbolZeusStatic",
        skeleton: "spSymbolZeusSkel",
        atlas: "spSymbolZeusAtlas"
    },
    16: {
        blurSymName: "spSymbolPoseidonBlur",
        staticSymName: "spSymbolPoseidonStatic",
        skeleton: "adderPoseidonSkel",
        atlas: "adderPoseidonAtlas"
    },
    17: {
        blurSymName: "spSymbolPoseidonBlur",
        staticSymName: "spSymbolPoseidonStatic",
        skeleton: "adderPoseidonSkel",
        atlas: "adderPoseidonAtlas"
    },
    18: {
        blurSymName: "spSymbolHadesBlur",
        staticSymName: "spSymbolHadesStatic",
        skeleton: "doublerHadesSkel",
        atlas: "doublerHadesAtlas"
    },
    19: {
        blurSymName: "spSymbolHadesBlur",
        staticSymName: "spSymbolHadesStatic",
        skeleton: "doublerHadesSkel",
        atlas: "doublerHadesAtlas"
    },
    20: {
        blurSymName: "spSymbolZeusBlur",
        staticSymName: "spSymbolZeusStatic",
        skeleton: "collectorZeusSkel",
        atlas: "collectorZeusAtlas"
    },
    21: {
        blurSymName: "spSymbolZeusBlur",
        staticSymName: "spSymbolZeusStatic",
        skeleton: "collectorZeusSkel",
        atlas: "collectorZeusAtlas"
    },
    23: {
        blurSymName: "blankSymbol",
        staticSymName: "blankSymbol",
        skeleton: "maxWinSkel",
        atlas: "maxWinAtlas"
    },
    24: {
        blurSymName: "spSymbolZeusBlur",
        staticSymName: "spSymbolZeusStatic",
        skeleton: "spSymbolZeusSkel",
        atlas: "spSymbolZeusAtlas"
    },
    25: {
        blurSymName: "spSymbolHadesBlur",
        staticSymName: "spSymbolHadesStatic",
        skeleton: "spSymbolHadesSkel",
        atlas: "spSymbolHadesAtlas"
    },
    26: {
        blurSymName: "spSymbolPoseidonBlur",
        staticSymName: "spSymbolPoseidonStatic",
        skeleton: "spSymbolPoseidonSkel",
        atlas: "spSymbolPoseidonAtlas"
    },
    // Add more mappings as needed
};

export function isOversizeSymbol(symbolIndex: number): boolean {

    let isSymbolOversize = false;
    if (symbolIndex == 0)// || symbolIndex == 9)
    {
        isSymbolOversize = false;
    }
    return isSymbolOversize;

}

export function isLandingAnimationExist(symbolIndex: number): boolean {

    let isLandingExist = true;
    if (symbolIndex == 0 || symbolIndex == 9) {
        isLandingExist = true;
    }
    return isLandingExist;
}

export function isIdleExist(symbolIndex: number): boolean {
    let isIdleExist = false;
    if (
        symbolIndex === 14
    ) {
        isIdleExist = true;
    }
    return isIdleExist;
}


export function getSymbol(symbolIndex: number, isFullRes?: boolean): Texture {

    let staticSymName: string = '';

    const symbol = symbolConfig[symbolIndex];

    if (symbol) {
        if (isFullRes && isFullRes == true) {
            staticSymName = symbol.staticSymName;
        }
        else {
            staticSymName = symbol.blurSymName;
        }
    }
    const staticSymbol: Texture = Texture.from(staticSymName);
    return staticSymbol;

}


export function getSpineSymbol(symbolIndex: number): Spine {
    const symbol = symbolConfig[symbolIndex];

    let skeletonVal: string = '';
    let atlasVal: string = '';

    if (symbol) {
        skeletonVal = symbol.skeleton;
        atlasVal = symbol.atlas;
    }

    try {
        const spineSymbol: Spine = Spine.from({
            skeleton: skeletonVal,
            atlas: atlasVal,
        });

        return spineSymbol;
    } catch (err) {
        console.error("Failed symbol:", {
            symbolIndex,
            skeleton: skeletonVal,
            atlas: atlasVal,
            error: err
        });
        throw err;
    }
}




